export interface TableConfig<T> {
  Columns: Column<T>[];
}

export interface Column<T> {
  columnType: ColumnType<T>;
  columnId: string;
  header: string;
  cellClass?: string | string[] | ((element?: T) => string | string[]);
  headerClass?: string | string[] | ((element?: T) => string | string[]);
  cellStyles?:
    | { [klass: string]: any }
    | { [klass: string]: any }[]
    | ((element?: T) => { [klass: string]: any } | { [klass: string]: any }[]);
}

export enum eColumnType {
  Text,
  Icon,
}

export interface ColumnType<T> {
  type: eColumnType;
  columnData?: any;
}

export interface TextColumnSuffix {
  text: string;
  cssClass?: string;
}

export class TextColumn<T> implements ColumnType<T> {
  readonly type: eColumnType = eColumnType.Text;

  columnData?: {
    valueSuffix?: (element: T) => TextColumnSuffix | null;
  };

  constructor(valueSuffix?: (element: T) => TextColumnSuffix | null) {
    if (valueSuffix) {
      this.columnData = { valueSuffix };
    }
  }
}

export class IconColumn<T> implements ColumnType<T> {
  readonly type: eColumnType = eColumnType.Icon;

  columnData?: {
    hasImage: (element?: T) => boolean;
    getImage: (element?: T) => string | null;
    /**
     * Optional: localized `alt` for the rendered icon (`<img>`).
     * a11y: when the icon conveys information (e.g. crowdedness level),
     * supply this so SR users get a textual equivalent. Returning `null`
     * or omitting the function leaves the icon decorative (`ng-icon`).
     */
    getAlt?: (element?: T) => string | null;
  };

  constructor(
    hasImage: (element?: T) => boolean,
    getImage: (element?: T) => string | null,
    getAlt?: (element?: T) => string | null
  ) {
    this.columnData = {
      getImage: getImage,
      hasImage: hasImage,
      getAlt: getAlt,
    };
  }
}
